




import { defineComponent, ref } from "@vue/composition-api"
import { FacilityTranslatableDetailsModel } from "@/app/models/facility-translatable-details.model"

export default defineComponent({
  props: {
    translationKey: {
      type: String,
      default: "",
    },
    details: {
      type: Array as () => Array<FacilityTranslatableDetailsModel>,
      default: () => [],
    },
  },
  setup(props, { root }) {
    const content = ref("")

    const translationDetail = props.details.find(translationDetail => {
      return translationDetail.locale === root.$i18n.locale
    })

    if (translationDetail) {
      switch (props.translationKey) {
        case "openingHours":
          content.value = translationDetail.openingHours
          break

        case "parkingHint":
          content.value = translationDetail.parkingHint
          break

        case "description":
          content.value = translationDetail.description
          break
      }
    } else {
      content.value =
        "TranslationDetail with locale: " + root.$i18n.locale + "  not found"
    }

    return {
      content,
    }
  },
})
